
export default {
	// Set VUE_APP_SERVER_BASE in .env.local to run against a local config server
	SERVER_BASE: process.env.VUE_APP_SERVER_BASE || "https://grenstall.shop4sale.se/branchstand_server/",
	API_URL: "https://kalls.se/headless/"
}